module.exports = __webpack_public_path__ + "assets/img/97374de7f937009635cf1fbcc0711fcd.svg";